import { pipe } from 'fp-ts/function';
import { record, string } from 'fp-ts';
import { OnboardingAuditArea, OnboardingAuditField, OnboardingAuditResult } from '@mews-commander/data-access';

const onlyMarketplace = (audit: OnboardingAuditField) => audit.area === OnboardingAuditArea.Marketplace;

export const marketplaceSelect = ({ legalEnvironmentData, kycStatus, ...auditChecks }: OnboardingAuditResult) =>
    pipe(
        auditChecks,
        record.filter(onlyMarketplace),
        record.collect(string.Ord)((_key, audit) => audit)
    );
